import { DialogContentText } from '@material-ui/core';
import { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { BaseEditIcon } from '../BaseEditIcon';
import { Account, AllowedRepositories, Features } from '../types';
import { RepositoryInput } from './RepositoryInput';
import { EditDeploymentRoleRepositories } from './EditDeploymentRoleRepositories';

interface DeploymentRoleEditIconProps {
  workloadData: Account | undefined;
  requesterEmail: string;
  features: Features;
  apiValidationPayload: any;
  isModalOpen: boolean;
  isLoading: boolean;
  isLoadingEdit: boolean;
  handleClickOpen: any;
  handleClose: any;
  handleConfirm: (event: React.FormEvent<HTMLFormElement>) => void;
  disableConfirm: boolean;
}

const DeploymentRoleEditIcon = (props: DeploymentRoleEditIconProps) => {
  const [localAllowedRepos, setLocalAllowedRepos] = useState(
    props.features.oidc?.allowed.repositories || [],
  );

  const handleRemoveRepo = (slug: string) => {
    setLocalAllowedRepos(
      localAllowedRepos.filter(
        (repo: AllowedRepositories) => repo.slug !== slug,
      ),
    );
  };

  const handleAddRepo = (slug: string) => {
    if (
      !localAllowedRepos.some((repo: AllowedRepositories) => repo.slug === slug)
    ) {
      setLocalAllowedRepos([...localAllowedRepos, { slug: slug }]);
    }
  };

  const handleConfirm = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (props.features.oidc) {
      props.features.oidc.allowed.repositories = localAllowedRepos;
    }
    props.handleConfirm(event);
  };

  const handleClose = () => {
    setLocalAllowedRepos(props.features.oidc?.allowed.repositories || []);
    props.handleClose();
  };

  return (
    <BaseEditIcon
      {...props}
      dialogTitle="Update"
      handleConfirm={handleConfirm}
      handleClose={handleClose}
      allowEngineerEdit
      allowOwnerEdit={false}
    >
      {props.features.oidc?.enabled ? (
        <EditDeploymentRoleRepositories
          allowedRepositories={localAllowedRepos}
          onRemoveRepo={handleRemoveRepo}
          onAddRepo={handleAddRepo}
        />
      ) : (
        <FormProvider {...props.apiValidationPayload.form}>
          <RepositoryInput
            apiValidation={props.apiValidationPayload}
            existingRepository={props.features?.oidc_cdk_role?.repos[0]}
          />
          <input
            type="hidden"
            name="pfg_owner"
            defaultValue={props.requesterEmail}
          />
          <DialogContentText>
            Updating an existing OIDC CDK Role will replace your current repo's
            access with the given repo. You will no longer be able to leverage
            this role to deploy into your account from the original repository.
          </DialogContentText>
          <DialogContentText>
            Setting the value to `blank` will remove any existing repositories
            from the OIDC CDK Role.
          </DialogContentText>
          <DialogContentText>
            The changes may take a few minutes to deploy and update depending on
            the feature.
          </DialogContentText>
        </FormProvider>
      )}
    </BaseEditIcon>
  );
};

export default DeploymentRoleEditIcon;
